<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.allScholarship)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/scholarship/new')">{{translate(locale.newScholarship)}}</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-50">
								<md-field>
									<label>{{translate(locale.searchScholarship)}}</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-field>
									<label>{{translate(locale.status)}}</label>
									<md-select :placeholder="translate(locale.statusAll)" v-model="search.status">
										<md-option value="">{{translate(locale.all)}}</md-option>
										<md-option value="1">{{translate(locale.active)}}</md-option>
										<md-option value="3">{{translate(locale.disabled)}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-25">
								<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="scholarshipList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.title)}}</md-table-head>
								<md-table-head>{{translate(locale.type)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.deadline)}}</md-table-head>
								<md-table-head style="min-width: 180px;">{{translate(locale.lastUpdate)}}</md-table-head>
								<md-table-head>{{translate(locale.status)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>

							<md-table-row v-for="(scholarship, index) in scholarshipList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><b>{{scholarship.name}}</b><br>{{translate(scholarship.location_country_name)}}</md-table-cell>
								<md-table-cell><b>{{translate(scholarship.scholarship_degree_name)}}</b><br>{{translate(scholarship.scholarship_type_name)}}</md-table-cell>
								<md-table-cell><b>{{translate(config.datelify(scholarship.deadline_date))}}</b><br>({{translate(config.timelify(scholarship.deadline_date))}})</md-table-cell>
								<md-table-cell><b>{{ scholarship.first_name }} {{ scholarship.last_name }}</b><br>{{ translate(config.datelify(scholarship.updated_date)) }}</md-table-cell>
								<md-table-cell>
									<span class="late" v-if="scholarship.status == 0">{{translate(locale.disabled)}}</span>
									<span class="gray" v-if="scholarship.status == 2">{{translate(locale.drafted)}}</span>
									<span class="green" v-if="scholarship.status == 1">{{translate(locale.active)}}</span>
								</md-table-cell>
								<md-table-cell>
									<a :href="config.redirect_url + '/scholarship/' + scholarship.hash" target="_blank">
										<md-button class="md-just-icon md-simple md-primary" v-if="scholarship.status == 1">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.viewThis)}}</md-tooltip>
										</md-button>
									</a>
									<md-button class="md-just-icon md-simple md-primary" v-if="scholarship.status == 0" @click="onEnable(scholarship.hash)">
										<md-icon>check_circle</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enableThis)}}</md-tooltip>
									</md-button>
									<md-button class="md-just-icon md-simple md-primary" v-if="scholarship.status == 2" @click="onEnable(scholarship.hash)">
										<md-icon>fact_check</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.enableThis)}}</md-tooltip>
									</md-button>
									<router-link :to="'scholarship/edit/' + scholarship.hash">
										<md-button class="md-just-icon md-simple md-info">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">{{translate(locale.editThis)}}</md-tooltip>
										</md-button>
									</router-link>

									<md-button class="md-just-icon md-simple md-warn" v-if="scholarship.status == 1" @click="onDisable(scholarship.hash)">
										<md-icon>hide_source</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.disableThis)}}</md-tooltip>
									</md-button>
									
									<md-button class="md-just-icon md-simple md-danger" v-if="scholarship.status == 0 || scholarship.status == 2" @click="onDelete(scholarship.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.deleteThis)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="scholarshipList.length == 0 && loaded == true">{{translate(locale.noScholarship)}}</h5>
						<div class="places-buttons text-center" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive" :md-title="translate(locale.deleteScholarship)" :md-confirm-text="translate(locale.delete)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
						<md-dialog-confirm :md-active.sync="disableDialogActive" :md-title="translate(locale.disableScholarship)" :md-confirm-text="translate(locale.disable)"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDisable" />
				</md-card-content>
			</md-card>
		</div>
	</div>
		
	</div>

</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				disableDialogActive: false, disableSelected: '',
				search: { text: "", status: "", type: "" },
				loadMore: false,
				scholarshipList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/profile/scholarship/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.scholarshipList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.scholarshipList = more ? this.scholarshipList.concat(data.body.data) : data.body.data;
				})
			},

			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete(hash) {
				if(this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/scholarship/delete", {
					hash: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have deleted the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onDisable(hash) {

				if(this.disableSelected == "") {
					this.disableDialogActive = true;
					this.disableSelected = hash;
					return;
				}
				this.$http.post(this.config.api + "/profile/scholarship/disable", {
					hash: this.disableSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have disabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/profile/scholarship/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the quotation/bidding successfully.",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.disableSelected = ""
				this.deleteDialogActive = false
				this.disableDialogActive = false
			},	
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Scholarship/View.vue